import React from 'react'

const ModalFooter = (props) => {
    return (
        <div className="flex items-center justify-end px-6 pt-6 pb-8 rounded-b gap-3">
            {props.children}

        </div>
    )
}

export default ModalFooter